module.exports = __webpack_public_path__ + "img/mouse.ec0ab172.png";